import React from "react";
import { ChevronLeft, ChevronsRight, Circle } from "react-feather";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";
import { PRIMARY_TEXT_COLOR } from "../../color";

const BulletList = ({ para }) => {
  return (
    <div style={{color:PRIMARY_TEXT_COLOR}}>
      <strong className="pr-2">
        <Circle size={6} fill={PRIMARY_TEXT_COLOR} />
      </strong>
      {para}
    </div>
  );
};

const TermsCondition = () => {
  return (
    <div className="mt-5" style={{ backgroundColor: "rgb(201 201 213 / 3%)" }}>
     
      <div>
        <Row >
          <Col md={{ size: 8, offset: 2 }} style={{color:PRIMARY_TEXT_COLOR}}>
            <CardBody>
              <div className="py-4 px-2 d-flex justify-content-center">
                <h6 className="headingMainStyle">
                  <span>Terms & Conditions</span>
                </h6>
              </div>
              <CardText style={{color:PRIMARY_TEXT_COLOR}}>
                <p style={{color:PRIMARY_TEXT_COLOR}} className="mb-4">
                  Welcome to betel Jobs, By registering as a candidate on our
                  platform, you agree to comply with and be bound by the
                  following Terms and Conditions. Please read them carefully
                  before proceeding.
                </p>
                <ol>
                  <li >
                    <strong>Agreement to Terms</strong>
                    <BulletList
                      para={
                        " By registering on Betel Jobs, you agree to be bound by these Terms and Conditions.If you do not agree to these Terms, please do not register or use the Portal."
                      }
                    />
                  </li>
                  <li style={{color:PRIMARY_TEXT_COLOR}}>
                    <strong>Use of the Portal</strong>
                    <ul className="">
                      <li >
                        <>   <Circle size={6} fill={PRIMARY_TEXT_COLOR} className="mr-2"  /> Candidate Responsibilities</>
                      </li>
                      <ul>
                        <li>
                          <strong className="px-2">
                            <ChevronsRight size={15} />
                          </strong>
                          Provide accurate and up-to-date information in your
                          profile.
                        </li>
                        <li>
                          <strong className="px-2">
                            <ChevronsRight size={15} />
                          </strong>
                          Use the Portal only for legitimate job search
                          purposes.
                        </li>
                        <li>
                          {" "}
                          <span className="px-2">
                            <ChevronsRight size={15} />
                          </span>
                          Comply with all applicable laws and regulations.
                        </li>
                        <li>
                          {" "}
                          <span className="px-2">
                            <ChevronsRight size={15} />
                          </span>
                          Refrain from any conduct that could be considered
                          harmful, offensive, or disruptive to the Portal or
                          other users.
                        </li>
                        <li>
                          {" "}
                          <span className="px-2">
                            <ChevronsRight size={15} />
                          </span>
                          Not use any automated means to access or interact with
                          the Portal, such as scripts or bots.
                        </li>
                      </ul>

                      <li>
                        <> <Circle size={6} fill={PRIMARY_TEXT_COLOR} className="mr-2" /> Portal Usage</>
                      </li>
                      <ul>
                        <li>
                          {" "}
                          <span className="px-2">
                            <ChevronsRight size={15} />
                          </span>
                          The Portal provides a platform for Candidates to
                          search for audit jobs and connect with potential
                          employers.
                        </li>
                        <li>
                          {" "}
                          <span className="px-2">
                            <ChevronsRight size={15} />
                          </span>
                          The Portal may provide access to job postings,
                          employer information, and other resources related to
                          audit careers.
                        </li>
                      </ul>
                    </ul>
                  </li>

                  <li>
                    <strong>Account Security</strong>
                    <ul>
                      <BulletList
                        para={
                          "The Candidate is responsible for maintaining the confidentiality of their account login credentials."
                        }
                      />
                      <BulletList
                        para={
                          "The Candidate must notify the Portal immediately of any unauthorized use of their account."
                        }
                      />
                    </ul>
                  </li>
                  <li>
                    <strong>Intellectual Property</strong>
                    <ul>
                      <BulletList
                        para={
                          "All content on the Portal, including but not limited to text, images, logos, and software, is protected by copyright and other intellectual property laws."
                        }
                      />
                      <BulletList
                        para={
                          "The Candidate may not use any content from the Portal for any commercial purpose without prior written consent from Betel Jobs."
                        }
                      />
                    </ul>
                  </li>
                  <li>
                    <strong>Disclaimer of Warranties</strong>
                    <ul>
                      <BulletList
                        para={
                          "The Portal is provided 'as is' and 'as available' without any warranties, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement."
                        }
                      />
                      <BulletList
                        para={
                          "Betel Jobs does not guarantee the accuracy, completeness, or reliability of any information on the Portal."
                        }
                      />
                    </ul>
                  </li>
                  <li>
                    <strong>Limitation of Liability</strong>
                    <BulletList
                      para={
                        "In no event shall Betel Jobs be liable for any damages whatsoever, including but not limited to direct, indirect, incidental, consequential, or punitive damages, arising out of or in connection with the use of the Portal."
                      }
                    />
                  </li>
                  <li>
                    <strong>Indemnification</strong>
                    <BulletList
                      para={
                        "The Candidate agrees to indemnify and hold harmless Betel Jobs from and against any claims, liabilities, damages, losses, and expenses arising out of or in connection with the Candidate's use of the Portal or violation of these Terms."
                      }
                    />
                  </li>
                  <li>
                    <strong>Modifications</strong>
                    <BulletList
                      para={
                        "Betel Jobs reserves the right to modify these Terms at any time without prior notice. The revised Terms will be effective upon posting on the Portal."
                      }
                    />
                  </li>
                  <li>
                    <strong>Governing Law</strong>
                    <BulletList
                      para={
                        "These Terms shall be governed by and construed in accordance with the laws."
                      }
                    />
                  </li>
                  <li>
                    <strong>Severability</strong>
                    <BulletList
                      para={
                        "If any provision of these Terms is held to be invalid or unenforceable, such provision shall be struck and the remaining provisions shall remain in full force and effect."
                      }
                    />
                  </li>
                  <li>
                    <strong>Contact</strong>
                    <BulletList
                      para={
                        "For any questions regarding these Terms, please contact the details provided on the Portal."
                      }
                    />
                  </li>
                  <li>
                    <strong>Entire Agreement</strong>
                    <BulletList
                      para={
                        "These Terms constitute the entire agreement between the Candidate and Betel Jobs with respect to the use of the Portal and supersede all prior or contemporaneous communications, representations,and understandings."
                      }
                    />
                  </li>
                </ol>
                <p className="my-3" style={{color:PRIMARY_TEXT_COLOR}}>
                  <strong>Disclaimer : </strong> This information is for general
                  guidance only and does not constitute legal advice.
                </p>
              </CardText>
            </CardBody>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TermsCondition;
